import * as React from 'react';
import {
    DocumentCard,
    DocumentCardTitle,
    DocumentCardDetails,
    DocumentCardImage,
} from '@fluentui/react/lib/DocumentCard';
import { ImageFit } from '@fluentui/react/lib/Image';
import { ICard } from '../CardContainer/cards';
import StandardButton from '../Buttons/StandardButton';
import DropdownButton from '../Buttons/DropdownButton';
import styles from './Card.module.css';
import { mergeStyles } from '@fluentui/react';

interface ICardProps extends ICard {
    eWayVersion: string;
    displayInFirstPosition?: boolean;
}

const Card: React.FC<ICardProps> = ({ title, img, link, btnText, btnOptions, eWayVersion, displayInFirstPosition }) => {
    return (
        <DocumentCard aria-label={title()} className={mergeStyles(styles.card, displayInFirstPosition && styles.displayInFirstPosition )}>
            <DocumentCardImage
                className={styles.cardImg}
                height={120}
                imageSrc={img}
                imageFit={ImageFit.centerContain}
            />
            <DocumentCardDetails>
                <DocumentCardTitle title={title()} className={styles.cardTitle} />
                {btnOptions ? (
                    <DropdownButton text={btnText()} btnOptions={btnOptions} />
                ) : (
                    <StandardButton text={btnText()} link={link({eWayVersion})} />
                )}
            </DocumentCardDetails>
        </DocumentCard>
    );
};

export default Card;
